<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      eager
      persistent
      scrollable
      max-width="900px"
    >
      <v-card>
        <v-card-title dark class="dialog-header pt-5 pb-5 pl-6">
          <span>Goals</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeD()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="max-height: 700px" class="my-4">
          <v-card>
            <v-row>
              <v-col cols="8" class="flex-items mt-2">
                <div class="ml-2 text-body-1">
                  {{ data ? data.title : "" }}
                </div>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="2" class="d-flex justify-end mt-2 mr-2">
                <v-btn
                  @click="AddFunction()"
                  class="white--text rounded-lg"
                  color="#519043"
                >
                  Add
                </v-btn>
              </v-col>
              <v-col cols="12" class=" pt-2 px-4">
                <v-data-table
                  :headers="headers"
                  :items="dataItem"
                  :items-per-page="10"
                >
                 
                  <template v-slot:[`item.action`]="{ item, index }">
                    <v-btn
                      block
                      x-small
                      class="mt-1"
                      outlined
                      color="green"
                      @click="addStrategic(item, index)"
                      >STRATEGIC OUTCOME</v-btn
                    >
                    <v-btn
                      x-small
                      class="mt-1"
                      @click="edit(item)"
                      outlined
                      color="blue"
                      block
                      >Update</v-btn
                    >
                    <!-- <v-btn
                      v-if="item.linked == null"
                      x-small
                      class="mt-1 mb-1"
                      @click="deleteItem(item)"
                      outlined
                      color="red"
                      block
                      >Delete</v-btn
                    > -->
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-5">
          <v-spacer></v-spacer>

          <v-btn color="red" outlined @click="closeD()">
            <v-icon>mdi-close-circle-outline</v-icon>
            Close
          </v-btn>

          <!-- <v-btn color="#519043" class="white--text" @click="submitTarget()">
              <v-icon>mdi-check-circle</v-icon>
              Submit
            </v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- delete dialog -->
    <v-dialog v-model="confirmDialog" persistent max-width="390">
      <v-card color="white">
        <div class="pa-4 #3a3b3a--text">
          <div class="text-h6 mb-1">WARNING!</div>
          <div class="text-body-1 mb-1">
            <p style="text-align: justify">
              <v-icon class="mt-n2" color="white">mdi-alert</v-icon> &nbsp; Are
              you sure you want to delete this information?<br /><br />
              Please note that
              <b>this action is irreversible.</b>
            </p>
          </div>
        </div>

        <!-- <v-card-title class="text-h5">
              Are you sure you want to proceed?
            </v-card-title> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="cancelDelete()">
            Close
          </v-btn>
          <v-btn
            :disabled="isButtonLoading"
            :loading="isButtonLoading"
            color="green"
            class="white--text"
            @click="confirmDelete()"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <addGoals :data="targetData" :action="action" />
    <viewStrategicOutcome
      :data="strategicData"
      :action="action"
      :goalIndex="goalIndex"
    />
    <fade-away-message-component
      displayType="variation2"
      v-model="fadeAwayMessage.show"
      :message="fadeAwayMessage.message"
      :header="fadeAwayMessage.header"
      :top="fadeAwayMessage.top"
      :type="fadeAwayMessage.type"
    ></fade-away-message-component>
  </div>
</template>

<script>
export default {
  components: {
    addGoals: () => import("./AddGoals.vue"),
    viewStrategicOutcome: () => import("./ViewStrategicOutcome.vue"),
  },
  props: {
    data: null,
  },
  data() {
    return {
      options: {},
      strategicData: null,
      action: null,
      goalIndex: null,
      desc: null,
      itemToDelete: null,
      confirmDialog: false,
      fadeAwayMessage: {
        show: false,
        type: "success",
        header: "Successfully Added!",
        message: "",
        top: 10,
      },
      dialog: false,
      activeTab: { id: 2, name: "Strategic Priority" },
      tab: 2,
      tabList: [{ id: 2, name: "Strategic Priority" }],
      targetData: null,
      id: null,
      isButtonLoading: false,
      dataItem: [],
      headers: [
            // {
        //   text: "No.",
        //   value: "strategic_planning_vp_goal_roleID",
        //   align: "start",
        //   valign: "start",
        //   width: 50,
        //   sortable: false,
        // },
        {
          text: "Description",
          value: "description",
          align: "start",
          valign: "start",
          sortable: false,
        },
        // {
        //   text: "Goal Assigned",
        //   value: "vp_goal_role_description",
        //   align: "center",
        //   valign: "center",
        //   width: 200,
        //   sortable: false,
        // },

        {
          text: "Action",
          value: "action",
          align: "center",
          valign: "center",
          width: 200,
        },
      ],
    };
  },

  watch: {
    data: {
      handler(data) {
        this.dialog = true;
        console.log("STRAT", data);
        this.id = data.id;
        this.tab = 1;
        this.initialize();
      },
      deep: true,
    },
    options: {
      handler() {
        this.initialize();
      },
      deep: true,
    },
  },
  mounted() {
    this.eventHub.$on("closeaddGoals", () => {
      this.initialize();
    });
    this.eventHub.$on("closeViewStrategicOutcome", () => {
      this.initialize();
    });
  },

  beforeDestroy() {
    this.eventHub.$off("closeaddGoals");

    this.eventHub.$off("closeViewStrategicOutcomed");
  },

  methods: {
    initialize() {
      this.loading = true;
      this.axiosCall("/strategic-planning-goal/" + this.id, "GET").then(
        (res) => {
          if (res) {
            this.dataItem = res.data;
            this.loading = false;
          }
        }
      );
    },

    closeD() {
      this.eventHub.$emit("closeGoals", false);
      this.dialog = false;
    },

    edit(item) {
      console.log(item);
      this.targetData = item;
      this.action = "Update";
    },
    addStrategic(item, index) {
      console.log(item, index + 1);
      this.strategicData = item;
      this.goalIndex = index + 1;
      this.action = "Add";
    },

    AddFunction() {
      this.targetData = { id: null, spID: this.id };
      this.action = "Add";
    },
    deleteItem(item) {
      this.itemToDelete = item;
      this.confirmDialog = true;
    },
    cancelDelete() {
      this.itemToDelete = null;
      this.confirmDialog = false;
    },

    confirmDelete() {
      this.isButtonLoading = true;
      console.log(this.itemToDelete.id);
      this.axiosCall(
        "/strategic-planning/deleteTarget/" + this.itemToDelete.id,
        "DELETE"
      ).then((res) => {
        if (res.data.status == 200) {
          this.confirmDialog = false;
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "success";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
          this.itemToDelete = null;
          this.confirmDialog = false;

          this.initialize();
        } else {
          this.fadeAwayMessage.show = true;
          this.fadeAwayMessage.type = "error";
          this.fadeAwayMessage.header = "System Message";
          this.fadeAwayMessage.message = res.data.msg;
          this.isButtonLoading = false;
        }
      });
    },

    changeTab(tab) {
      this.activeTab = tab;
      this.tab = tab.id;
      this.initialize();
    },
  },
};
</script>
<style scoped></style>
